/**
 * Doorbijters Theme - Main JavaScript Entry
 * ==========================================
 * This file bundles all non-critical JavaScript.
 * Critical JS for above-the-fold content should go in critical.js
 */

// ── Site-wide modules ───────────────────────────────────────────────────────
import './components/forms-floating-labels.js';
import { initMobileNav }    from './components/mobile-nav.js';
import { initSmoothScroll } from './components/smooth-scroll.js';
import { initThemeToggle }  from './components/theme-toggle.js';
import { initFooter }       from './components/footer.js';
import { initProductGrid } from './elementor/widgets/product-grid.js';
import { initProductCarousel } from './elementor/widgets/product-carousel.js';
import { initProductBundleShowcase } from './elementor/widgets/product-bundle-showcase.js';
import { initBrandsWidget } from './elementor/widgets/brands.js';
import { initStickyAddToCart } from './elementor/widgets/sticky-add-to-cart.js';
import { initFaqAccordion } from './elementor/widgets/faq-accordion.js';
import { initPromoCountdown } from './elementor/widgets/promo-countdown.js';
import { initSingleProduct } from './woocommerce/single-product.js';
import { initVariationSwatches } from './woocommerce/variation-swatches.js';
import { initArchiveFilters } from './woocommerce/archive-filters.js';

// ── GSAP animations ─────────────────────────────────────────────────────────
import { initHeaderAnimation }  from './animations/header.js';
import { initHeroAnimation }    from './animations/hero.js';
import { initScrollAnimations } from './animations/scroll.js';
import { initButtonAnimations } from './animations/buttons.js';

initHeaderAnimation();
initHeroAnimation();
initScrollAnimations();
initSmoothScroll();

// Carousel must init before the global button/grid binders below: Swiper's
// loop mode clones slide DOM nodes (copying any data-*-init attributes with
// them), so cards need their real event listeners attached — via the
// carousel's own scoped init — before those flags could get pre-copied onto
// clones and make the global scan below skip them.
initProductCarousel();
initProductBundleShowcase();

initButtonAnimations();
initMobileNav();
initThemeToggle();
initFooter();
initProductGrid();
initSingleProduct();
initVariationSwatches();
initArchiveFilters();
initBrandsWidget();
initStickyAddToCart();
initFaqAccordion();
initPromoCountdown();
